import React from "react"
import {Box} from "@mui/material"


export default function ColorSquare({ value }) {
	return <Box sx={{ 
		backgroundColor: value,
		width: 15, height: 15,
		borderRadius: 2
	 }} />
}